import React, { Component } from 'react';

class RubroExcepcionRadioButton extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12" key={this.props.key} >
                    <div className="container-radio radio-margin left-padding-xs">
                        <input
                            id={this.props.id}
                            type="radio"
                            name="rubro"
                            checked={this.props.checked}
                            enabled={this.props.enabled}
                            value={this.props.value}
                            onChange={this.props.filtroRubro}
                            required />
                        <label className="label-secondary top-separator-xxs" htmlFor={this.props.id}>{this.props.title}</label>
                    </div>
                </div>
            </div>);
    }
};

export default RubroExcepcionRadioButton;